export enum IntegrationMappingHttpResponse {
    SuccessAdd = 'Integration Mapping was added successfully.',
    SuccessUpdate = 'Integration Mapping was updated successfully.',
    SuccessDelete = 'Integration Mapping was deleted successfully.',
    Error = 'An error occurred during request.'
}
